import { createContext, useContext } from "react";

/*
 * The context object and its hook live apart from the provider component.
 *
 * Why: react-refresh can only fast-refresh a module that exports *only*
 * components. Mixing a provider component with a hook or a constant in one file
 * downgrades every edit to a full page reload. Splitting costs one small file
 * and keeps HMR working — the same split is used for AuthContext.
 */

export const THEME_STORAGE_KEY = "ptt-theme";

export const ThemeContext = createContext(null);

export function useTheme() {
    const ctx = useContext(ThemeContext);
    if (!ctx) throw new Error("useTheme must be used inside <ThemeProvider>");
    return ctx;
}
